import type { IImageSize } from './types';
import { formatSrc } from './utils';

export interface IResponsiveImageProps {
  children?: React.ReactNode;
  sizes?: IImageSize[];
  src: string;
}

const ResponsiveImage = ({ children, sizes = [], src }: IResponsiveImageProps): JSX.Element => {
  if (!sizes.length) return <>{children}</>;

  return (
    <picture>
      {sizes?.map(({ maxWidth, size }, i) => {
        const key = `${src}-${size}-${i}`;
        const srcSet = formatSrc(src, size);

        return maxWidth ? (
          <source key={key} srcSet={srcSet} media={`(max-width: ${maxWidth}px)`} />
        ) : (
          <source key={key} srcSet={srcSet} />
        );
      })}
      {children}
    </picture>
  );
};

export default ResponsiveImage;
